import React from "react";
import { Helmet } from "react-helmet";

const page = [
  { pathName: "servis", pageName: "Servis" },
  function () {
    return (
      <div className="subPages_hizmetlerimiz-defaultCard TKM_7145">
        <Helmet>
          <title>Kampüs Kreş - Servis</title>
          <meta name="title" content="Kampüs Kreş - Servis" />
          <meta property="og:title" content="Kampüs Kreş - Servis" />
          <meta name="twitter:title" content="Kampüs Kreş - Servis" />

          <meta
            name="keywords"
            content="kreş servis hizmeti, servis hizmeti, kampüs kreş servis"
          />
        </Helmet>
        <div className="subPages_hizmetlerimiz-defaultCard_firstColumn">
          <p>
            <strong>Kampüs Kreş</strong> olarak, öğrencilerimizin okula ulaşım
            sürecinde güvenliği ve konforu en üst düzeyde tutmayı hedefliyoruz.{" "}
            <strong>Kreş ve anaokulu</strong> kademelerinde hizmet alan
            çocuklarımız için öğrenci taşıma hizmeti, sektörün önde gelen
            firmalarından biri olan <strong>Aktif Tur</strong> ile iş birliği
            içinde sağlanmaktadır.
            <br />
            <br />
            Kullanılan servis araçları, teknolojik açıdan donanımlı, yeni model
            ve tüm güvenlik standartlarına uygun olacak şekilde hizmet
            vermektedir. Özellikle <strong>okul öncesi</strong> yaş grubundaki
            çocuklarımızın güvenliği için her detay düşünülmüştür.
          </p>
          <div
            className="img"
            style={{
              background: `url(${require("../../../../assets/TKM_7145.jpg")})`,
            }}
          />
        </div>
        <div className="subPages_hizmetlerimiz-defaultCard_secondColumn">
          <p>
            Araçlarımızda:
            <ul style={{ paddingBlock: "10px" }}>
              <li>Her koltukta emniyet kemeri bulunmaktadır,</li>

              <li>Bebeklerimiz için özel oto koltukları kullanılmaktadır,</li>

              <li>
                Tüm araçlar Emniyet Müdürlüğü’nün belirlediği standartlara tam
                uyumludur,
              </li>

              <li>Yolculuk süresince öğrencilerimiz sigorta kapsamındadır.</li>
            </ul>
            <strong>Kampüs Kreş’te</strong> öğrencilerimiz, sabah saatlerinde
            hostes eşliğinde evlerinden güvenli bir şekilde alınarak,{" "}
            <strong>kreş</strong>
            öğretmenlerine bire bir teslim edilmektedir. Aynı şekilde, gün
            sonunda hostes gözetiminde öğretmenlerden teslim alınarak en
            güvenli, hızlı ve doğru şekilde evlerine ulaştırılmaktadır.
            <br />
            <br />
            Servis aracı <strong>Kampüs Kreş</strong> yerleşkesine ulaştığında,
            tüm öğrenciler indikten sonra güvenlik görevlilerimiz araç içine
            girerek son kontrolleri gerçekleştirmekte ve ardından araç kampüsten
            ayrılmaktadır. Bu sistem, çocuklarımızın{" "}
            <strong>çocuk gelişimi</strong> sürecinde hem güvenli ulaşım hem de
            disiplinli bir alışkanlık geliştirmelerine katkı sağlamaktadır.
            <br />
            <br />
            <strong>Anaokulu</strong> düzeyindeki öğrencilerimizin okul
            yolculuğu, <strong>çocuk gelişimi</strong>
            ilkeleri göz önünde bulundurularak planlanmakta ve servis süreçleri
            sürekli olarak denetlenmektedir.
          </p>
        </div>
      </div>
    );
  },
];

export default page;
